import type { ComponentProps, ReactNode } from 'react';
import type { Except } from 'type-fest';
import { Typography } from '../Typography';
import styles from './styles.module.css';

type HtmlLabelProps = ComponentProps<'label'>;
export type LabelProps = Except<HtmlLabelProps, 'htmlFor' | 'children' | 'color'> &
  Required<Pick<HtmlLabelProps, 'htmlFor' | 'children'>>;

/** @deprecated use Label from kitt-universal instead */
export function Label({ htmlFor, children, ...props }: LabelProps): ReactNode {
  return (
    <Typography tag="label" base="body" className={styles.Label} htmlFor={htmlFor} {...props}>
      {children}
    </Typography>
  );
}
